/**
 * @generated SignedSource<<c8e4c660aa57662d70c7ccc1dee20c8b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PullRequestRowSecondary$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckRunStatusFromPullRequest" | "IssuePullRequestStateIconSecondary" | "ReviewDecision">;
  readonly " $fragmentType": "PullRequestRowSecondary";
};
export type PullRequestRowSecondary$key = {
  readonly " $data"?: PullRequestRowSecondary$data;
  readonly " $fragmentSpreads": FragmentRefs<"PullRequestRowSecondary">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PullRequestRowSecondary",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "IssuePullRequestStateIconSecondary"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ReviewDecision"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckRunStatusFromPullRequest"
    }
  ],
  "type": "PullRequest",
  "abstractKey": null
};

(node as any).hash = "7c5bae3057e123c5586a02174e11a833";

export default node;
